module.exports = __webpack_public_path__ + "static/img/qa.33716533.svg";